
import { Link } from "react-router-dom";
import { 
  Github, 
  Twitter, 
  Youtube, 
  Linkedin 
} from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-secondary py-12 mt-12">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="flex flex-col space-y-4">
            <h3 className="text-lg font-semibold text-primary">FlowMarket</h3>
            <p className="text-sm text-muted-foreground">
              Discover and share powerful automation workflows for your favorite no-code tools.
            </p>
            <div className="flex items-center space-x-4 pt-2">
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                <Twitter className="h-5 w-5 text-foreground hover:text-primary transition-colors" />
              </a>
              <a href="https://github.com" target="_blank" rel="noopener noreferrer">
                <Github className="h-5 w-5 text-foreground hover:text-primary transition-colors" />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
                <Youtube className="h-5 w-5 text-foreground hover:text-primary transition-colors" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                <Linkedin className="h-5 w-5 text-foreground hover:text-primary transition-colors" />
              </a>
            </div>
          </div>
          
          <div className="flex flex-col space-y-3">
            <h3 className="text-sm font-semibold">Marketplace</h3>
            <Link to="/marketplace?category=zapier" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              Zapier Templates
            </Link>
            <Link to="/marketplace?category=make" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              Make.com Templates
            </Link>
            <Link to="/marketplace?category=n8n" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              n8n Templates
            </Link>
            <Link to="/marketplace?category=automation" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              All Automation Tools
            </Link>
          </div>
          
          <div className="flex flex-col space-y-3">
            <h3 className="text-sm font-semibold">Sell</h3>
            <Link to="/sell" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              Start Selling
            </Link>
            <Link to="/seller-guide" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              Seller Guide
            </Link>
            <Link to="/pricing" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              Pricing & Commissions
            </Link>
            <Link to="/seller-dashboard" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              Seller Dashboard
            </Link>
          </div>
          
          <div className="flex flex-col space-y-3">
            <h3 className="text-sm font-semibold">Legal & Company</h3>
            <Link to="/about" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              About Us
            </Link>
            <Link to="/privacy" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              Terms of Service
            </Link>
            <Link to="/contact" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              Contact Us
            </Link>
          </div>
        </div>
        
        <div className="mt-12 pt-6 border-t border-border text-center">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} FlowMarket. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
